module.exports = __webpack_public_path__ + "04_short_brown.2e0e07d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_short_brown.png
// module id = y8UJ
// module chunks = 0